<template>
  <div class="book">
    <div class="row">
      <div class="col-8 d-md-none"><book-title :book="book" /></div>
      <div class="col-4 col-md-3 order-md-last">
        <img
          :src="coverImage(book.img)"
          class="img-fluid"
          :alt="`Buchdeckel von ${book.title}`"
        />
      </div>
      <div class="col-12 col-md-9">
        <book-title :book="book" class="d-none d-md-block" />
        <div class="my-3" v-html="book.description"></div>
        <dl class="row text-muted small">
          <dt class="col-12 col-md-2">Verlag</dt>
          <dd class="col-12 col-md-10">
            {{ book.publisher }} ({{ book.publishingYear }})
          </dd>
          <dt class="col-12 col-md-2">ISBN</dt>
          <dd class="col-12 col-md-10">{{ book.isbn }}</dd>
        </dl>
        <div>
          <strong class="d-block mb-1">Jetzt kaufen bei:</strong>
          <a
            class="buy-link"
            v-for="{ link, type } in book.buyLinks"
            :key="type"
            :href="link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img :src="image(type)" :alt="type" />
          </a>
        </div>
        <small class="text-muted">
          Alle Links sind Affiliate-Links. Als Partner von Amazon, Weltbild und
          Jokers verdiene ich an qualifizierten Käufen.
        </small>
      </div>
    </div>
  </div>
</template>
<script>
import BookTitle from "@/components/BookTitle";

const imageContext = require.context("@/assets/", false, /\.jpg$/);
const coverContext = require.context("@/assets/books/", false, /\.jpg$/);

export default {
  components: {
    BookTitle
  },
  props: {
    book: { required: true }
  },
  methods: {
    image: type => {
      return imageContext(`./${type}.jpg`);
    },
    coverImage: type => {
      return coverContext(`./${type}.jpg`);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "~@/scss/mixins";

.buy-link {
  display: inline-block;
  padding: $spacer * 0.35;
  border: 1px solid $border-color;
  transition: all 0.1s ease-out;
  filter: saturate(0.9);
  border-radius: $border-radius;

  &:hover {
    box-shadow: $box-shadow-sm;
    border-color: darken($border-color, 15%);
    filter: none;
  }

  margin-bottom: $spacer * 0.75;
  &:not(:last-child) {
    margin-right: $spacer;
  }

  img {
    max-height: 2.6em;
  }
}
</style>
